import React from "react";

export default function Shimmer() {
  return (
    <div className="p-8 flex justify-center flex-wrap gap-10">
      <div className="border border-slate-500 shadow rounded-md p-4 mt-10 max-w-xs w-full mx-auto animate-pulse">
        <div className=" flex space-x-4 ">
          <div className="rounded-full  bg-slate-300 h-10 w-10"></div>
          <div className="flex-1 space-y-6 py-1">
            <div className="h-2 bg-slate-300 rounded"></div>
            <div className="space-y-3">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-2 bg-slate-300 rounded col-span-2"></div>
                <div className="h-2 bg-slate-300 rounded col-span-1"></div>
              </div>
              <div className="h-2 bg-slate-300 rounded"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="border border-slate-500 shadow rounded-md p-4 mt-10 max-w-xs w-full mx-auto animate-pulse">
        <div className=" flex space-x-4 ">
          <div className="rounded-full  bg-slate-300 h-10 w-10"></div>
          <div className="flex-1 space-y-6 py-1">
            <div className="h-2 bg-slate-300 rounded"></div>
            <div className="space-y-3">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-2 bg-slate-300 rounded col-span-2"></div>
                <div className="h-2 bg-slate-300 rounded col-span-1"></div>
              </div>
              <div className="h-2 bg-slate-300 rounded"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="border border-slate-500 shadow rounded-md p-4 mt-10 max-w-xs w-full mx-auto animate-pulse">
        <div className=" flex space-x-4 ">
          <div className="rounded-full  bg-slate-300 h-10 w-10"></div>
          <div className="flex-1 space-y-6 py-1">
            <div className="h-2 bg-slate-300 rounded"></div>
            <div className="space-y-3">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-2 bg-slate-300 rounded col-span-2"></div>
                <div className="h-2 bg-slate-300 rounded col-span-1"></div>
              </div>
              <div className="h-2 bg-slate-300 rounded"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="border border-slate-500 shadow rounded-md p-4 mt-10 max-w-xs w-full mx-auto animate-pulse">
        <div className=" flex space-x-4 ">
          <div className="rounded-full  bg-slate-300 h-10 w-10"></div>
          <div className="flex-1 space-y-6 py-1">
            <div className="h-2 bg-slate-300 rounded"></div>
            <div className="space-y-3">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-2 bg-slate-300 rounded col-span-2"></div>
                <div className="h-2 bg-slate-300 rounded col-span-1"></div>
              </div>
              <div className="h-2 bg-slate-300 rounded"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="border border-slate-500 shadow rounded-md p-4 mt-10 max-w-xs w-full mx-auto animate-pulse">
        <div className=" flex space-x-4 ">
          <div className="rounded-full  bg-slate-300 h-10 w-10"></div>
          <div className="flex-1 space-y-6 py-1">
            <div className="h-2 bg-slate-300 rounded"></div>
            <div className="space-y-3">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-2 bg-slate-300 rounded col-span-2"></div>
                <div className="h-2 bg-slate-300 rounded col-span-1"></div>
              </div>
              <div className="h-2 bg-slate-300 rounded"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="border border-slate-500 shadow rounded-md p-4 mt-10 max-w-xs w-full mx-auto animate-pulse">
        <div className=" flex space-x-4 ">
          <div className="rounded-full  bg-slate-300 h-10 w-10"></div>
          <div className="flex-1 space-y-6 py-1">
            <div className="h-2 bg-slate-300 rounded"></div>
            <div className="space-y-3">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-2 bg-slate-300 rounded col-span-2"></div>
                <div className="h-2 bg-slate-300 rounded col-span-1"></div>
              </div>
              <div className="h-2 bg-slate-300 rounded"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
